import AU_LOCAL from '../../../public/payout_schema_examples_samples/AU_LOCAL.json';
import BE_SEPA from '../../../public/payout_schema_examples_samples/BE_SEPA.json';
import BR_PIX from '../../../public/payout_schema_examples_samples/BR_PIX.json';
import CA_LOCAL from '../../../public/payout_schema_examples_samples/CA_LOCAL.json';
import DE_INSTANT_SEPA from '../../../public/payout_schema_examples_samples/DE_INSTANT_SEPA.json';
import DK_LOCAL from '../../../public/payout_schema_examples_samples/DK_LOCAL.json';
import ES_SEPA from '../../../public/payout_schema_examples_samples/ES_SEPA.json';
import IN_LOCAL from '../../../public/payout_schema_examples_samples/IN_LOCAL.json';
import JP_LOCAL from '../../../public/payout_schema_examples_samples/JP_LOCAL.json';
import NL_INSTANT_SEPA from '../../../public/payout_schema_examples_samples/NL_INSTANT_SEPA.json';
import NZ_LOCAL from '../../../public/payout_schema_examples_samples/NZ_LOCAL.json';
import PT_SEPA from '../../../public/payout_schema_examples_samples/PT_SEPA.json';

export const PAYOUT_SCHEMAS_AND_EXAMPLES_SAMPLES = [
  AU_LOCAL,
  BE_SEPA,
  BR_PIX,
  CA_LOCAL,
  DE_INSTANT_SEPA,
  DK_LOCAL,
  ES_SEPA,
  IN_LOCAL,
  JP_LOCAL,
  NL_INSTANT_SEPA,
  NZ_LOCAL,
  PT_SEPA
];
